import React from 'react';
import PropTypes from 'prop-types';
import grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Header = props => {
    const { height } = props;

    const goBack = () => {
        grounds.close();
    };

    return (
        <div
            className={styles.header}
            id="header"
            style={{
                paddingTop: `${height}px`,
            }}>
            <div>
                <span className={styles.tool} onClick={goBack}>
                    <img src="https://x0.ifengimg.com/ucms/2021_40/3F4E1979DE5A7A9B94061DD6BC83D341B0EB1549_size1_w30_h54.png" />
                </span>
            </div>
        </div>
    );
};

Header.propTypes = {
    height: PropTypes.number,
};

export default errorBoundary(Header);
